import { motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';

import checkIconSVG from '@krea/common/images/svg/check-colorless.svg';
import PreloaderSVG from '@krea/common/images/svg/preloader.svg';
import { Text } from '@krea/common/shared-components/text';
import { useIsFieldRequestSubmitting } from '@krea/common/store/field-requests/hooks/mutations';
import { useGetOneFieldRequest } from '@krea/common/store/field-requests/hooks/queries';
import twMerge from '@krea/common/utils/tailwind-utils';

const motionLabel = {
  hidden: {
    backgroundColor: '#989898',
  },
  visible: {
    backgroundColor: '#39008c',
  },
};

const FieldRequestSaved = ({
  className,
  fieldRequestID,
  ...otherProps
}: {
  className?: string;
  fieldRequestID?: number;
  text?: React.ReactNode;
  isSubmitting?: boolean;
  isSubmitted?: boolean;
}) => {
  const { t } = useTranslation();
  const isFRSubmitting = fieldRequestID
    ? useIsFieldRequestSubmitting(fieldRequestID)
    : null;
  const { data: { isSubmitted: isFRSubmitted } = {} } =
    useGetOneFieldRequest(fieldRequestID);

  const isSubmitting = fieldRequestID
    ? isFRSubmitting
    : otherProps.isSubmitting;
  const isSubmitted = fieldRequestID ? isFRSubmitted : otherProps.isSubmitted;

  return (
    <motion.div
      key="done"
      variants={motionLabel}
      initial={false}
      animate={isSubmitted ? 'visible' : 'hidden'}
      // TODO : Not perfect yet, need to fix
      className={twMerge(
        'tw-flex tw-items-center tw-justify-center tw-absolute tw-text-white tw-top-0 tw-right-0 tw-z-10 tw-h-7 tw-min-w-7 tw-rounded-bl-lg tw-rounded-tr-lg tw-w-auto tw-max-w-full tw-py-1',
        className,
      )}
    >
      {isSubmitting ? (
        <div className={twMerge('tw-relative tw-text-white tw-w-5 tw-h-5')}>
          <SVG className="tw-absolute tw-w-2 tw-h-auto" src={PreloaderSVG} />
        </div>
      ) : isSubmitted ? (
        <div
          className={twMerge(
            'tw-w-4 tw-h-4',
            'd-inline-flex align-items-center justify-content-center rounded-circle align-middle bg-white text-primary',
            className,
          )}
        >
          <SVG
            className="tw-absolute tw-w-2 tw-h-auto tw-text-current tw-fill-current"
            src={checkIconSVG}
          />
        </div>
      ) : (
        <div>
          <Text
            size="sm"
            className="text-white font-weight-bold px-3 text-[0px] leading-[0]"
          >
            {t('iaq.applicationPreview.incomplete')}
          </Text>
        </div>
      )}
    </motion.div>
  );
};

export default FieldRequestSaved;
